<template>
  <svg v-if="isMguuDesign" width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M1.6281 0.279338C1.25565 -0.0931124 0.651788 -0.0931124 0.279338 0.279338C-0.0931125 0.651788 -0.0931125 1.25565 0.279337 1.6281L3.65124 5L0.279338 8.3719C-0.0931125 8.74435 -0.0931122 9.34821 0.279338 9.72066C0.651788 10.0931 1.25565 10.0931 1.6281 9.72066L5 6.34876L8.3719 9.72066C8.74435 10.0931 9.34821 10.0931 9.72066 9.72066C10.0931 9.34821 10.0931 8.74435 9.72066 8.3719L6.34876 5L9.72066 1.6281C10.0931 1.25565 10.0931 0.651788 9.72066 0.279338C9.34821 -0.0931124 8.74435 -0.0931127 8.3719 0.279338L5 3.65124L1.6281 0.279338Z" fill="#12122C"/>
  </svg>
  <svg v-else width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M6.99999 5.58599L11.95 0.635986L13.364 2.04999L8.41399 6.99999L13.364 11.95L11.95 13.364L6.99999 8.41399L2.04999 13.364L0.635986 11.95L5.58599 6.99999L0.635986 2.04999L2.04999 0.635986L6.99999 5.58599Z" fill="currentColor"/>
  </svg>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: "#000000",
    },
  },
  computed: {
    isMguuDesign() {
      return this.app_design_type === 'mguu' && this.$store.getters.authUserRoleSlug === 'respondent';
    }
  }
}
</script>

<style scoped>

</style>